import footerLogoIcon from '@/assets/img/home/footerLogo.svg';
import inLogoIcon from '@/assets/img/home/inLogo.svg';
import youtubeLogoIcon from '@/assets/img/home/youtubeLogo.svg';

const routes = [
  {
    title: 'Industries',
    links: [
      { label: 'Construction', href: 'https://gpmgis.com/construction' },
      { label: 'OSP', href: 'https://gpmgis.com/osp' },
      { label: 'Fulfilment', href: 'https://gpmgis.com/fulfilment' },
      { label: 'Power', href: 'https://gpmgis.com/power' },
      { label: 'Forestry', href: 'https://gpmgis.com/forestry' },
      { label: 'Mining', href: 'https://gpmgis.com/mining' },
    ],
  },
  {
    title: 'Modules',
    links: [
      { label: 'GPM', href: 'https://gpmgis.com/#gpm' },
      { label: 'WYMS', href: 'https://gpmgis.com/#wyms' },
      { label: 'Data Sphere', href: 'https://gpmgis.com/#data-sphere' },
      { label: 'Payroll', href: 'https://gpmgis.com/#payroll' },
    ],
  },
  {
    title: 'About',
    links: [
      { label: 'Why Us', href: 'https://gpmgis.com/#why-us' },
      { label: 'Architecture', href: 'https://gpmgis.com/#architecture' },
      { label: 'Testimonials', href: 'https://gpmgis.com/#testimonials' },
    ],
  },
];

/**
 * Public landing footer — faithful port of the legacy reipm
 * `components/home/Footer.tsx` (GPM logo, "Developed by US Software
 * Solutions", gpmgis.com link columns, Follow Us socials, copyright line).
 * Named `HomeFooter` to avoid colliding with future app-shell footers.
 */
export const HomeFooter = () => {
  return (
    <>
      <div className="flex justify-center border-t-2 border-[#0061E5]">
        <div className="grid w-full max-w-[1920px] grid-cols-12 bg-white px-3 py-12 md:px-24">
          <div className="col-span-12 mb-[70px] flex flex-col items-center justify-center lg:col-span-2 lg:mb-0">
            <img src={footerLogoIcon} alt="GPM Logo" width={81} height={81} />
            <p className="mt-3 text-center font-medium text-[#5D6268]">Developed by</p>
            <a
              className="mb-5 text-center font-medium text-[#5D6268] underline"
              href="https://ussoftwaresolutions.us/"
              target="_blank"
              rel="noreferrer"
            >
              US Software Solutions
            </a>
          </div>
          <div className="col-span-12 flex justify-center space-x-10 md:space-x-16 lg:col-span-8">
            <div className="grid grid-cols-2 gap-8 md:grid-cols-4 lg:grid-cols-3 xl:gap-16">
              {routes.map(({ title, links }, idx) => (
                <div key={idx} className="flex flex-col">
                  <p className="text-[24px] font-bold text-[#0061E5]">{title}</p>
                  <div className="flex flex-col space-y-2">
                    {links.map(({ label, href }, i) => (
                      <a target="_blank" rel="noreferrer" key={i} className="text-[18px] text-[#929395]" href={href}>
                        {label}
                      </a>
                    ))}
                  </div>
                </div>
              ))}
              <div className="block lg:hidden">
                <p className="text-center text-[24px] font-bold text-[#0061E5] md:text-left">Follow Us</p>
                <div className="mt-4 flex">
                  <a href="https://www.facebook.com/USSoftwareSolutions" target="_blank" rel="noreferrer">
                    <img className="mr-[15px]" src={youtubeLogoIcon} alt="Facebook Logo" width={40} height={40} />
                  </a>
                  <a href="https://linkedin.com/company/ussoftwaresolutions" target="_blank" rel="noreferrer">
                    <img src={inLogoIcon} alt="LinkedIn Logo" width={40} height={40} />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="hidden flex-col items-center justify-center space-y-2 lg:col-span-2 lg:flex lg:items-end lg:justify-start">
            <div>
              <p className="text-center text-[24px] font-bold text-[#0061E5] md:text-left">Follow Us</p>
              <div className="mt-4 flex">
                <a
                  href="https://www.linkedin.com/company/geolocation-program-management/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img className="mr-[15px]" src={inLogoIcon} alt="LinkedIn Logo" width={40} height={40} />
                </a>
                <a href="https://www.youtube.com/@GeolocationProgramManagement" target="_blank" rel="noreferrer">
                  <img src={youtubeLogoIcon} alt="Facebook Logo" width={40} height={40} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p className="px-3 text-center text-[#92939599]">
        Geolocation Program Management {new Date().getFullYear()}. All rights reserved
      </p>
    </>
  );
};
